import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    searchByPrefix: ({ field }: {
        field: string;
    }) => string;
    searchVisuals: string;
    fieldStatus: string;
    fieldComments: string;
    fieldFormat: string;
    fieldTranscription: string;
    fieldDate: string;
    fieldKeyword: string;
    fieldUploader: string;
    fieldResolution: string;
    fieldDuration: string;
    fieldFileSize: string;
    fieldAssignee: string;
    fieldFileType: string;
    descriptionStatusApproved: string;
    descriptionCommentsCount: string;
    descriptionVisualsCars: string;
    descriptionFormat: string;
    descriptionTranscriptionFlour: string;
    descriptionDateDays: string;
    descriptionKeywordExploratory: string;
    descriptionUploaderJeremiah: string;
    descriptionCommentsLighting: string;
    descriptionVisualsMountains: string;
    descriptionTranscriptionLaunch: string;
    descriptionDateMonths: string;
    descriptionKeywordConfidential: string;
    descriptionUploaderThomas: string;
    descriptionResolution: string;
    descriptionDurationShorter: string;
    descriptionFileSizeLarger: string;
    descriptionCommentsApproved: string;
    descriptionVisualsPerson: string;
    descriptionTranscriptionBudget: string;
    descriptionDateBefore: string;
    descriptionKeywordMarketing: string;
    descriptionAssignee: string;
    descriptionFileType: string;
    descriptionFileSizeSmaller: string;
    descriptionDurationLonger: string;
    descriptionStatusNeedsReview: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title prefix for search by field (e.g., "Search by Status") */
            searchByPrefix: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ field }: {
                        field: string;
                    }): string => __intl__.intl().formatMessage({ id: "suggestionsText.searchByPrefix?c=skkcz4lvkq0r", defaultMessage: "Search by {field}" }, { field: field }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title for visual search (special case without "by") */
            searchVisuals: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.searchVisuals?c=19mda2pq9nl23", defaultMessage: "Search Visuals" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Status */
            fieldStatus: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldStatus?c=2rksycb4ttyye", defaultMessage: "Status" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Comments */
            fieldComments: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldComments?c=30ob2za738yys", defaultMessage: "Comments" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Format */
            fieldFormat: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldFormat?c=1c78rgt8tj045", defaultMessage: "Format" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Transcription */
            fieldTranscription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldTranscription?c=3eqbqmosyq5dt", defaultMessage: "Transcription" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Date */
            fieldDate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldDate?c=17w332jbk02uj", defaultMessage: "Date" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Keyword */
            fieldKeyword: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldKeyword?c=18th6zgvg6623", defaultMessage: "Keyword" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Uploader */
            fieldUploader: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldUploader?c=132057d81z0ix", defaultMessage: "Uploader" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Resolution */
            fieldResolution: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldResolution?c=3amgwip293t7i", defaultMessage: "Resolution" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Duration */
            fieldDuration: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldDuration?c=258yol3wtes0j", defaultMessage: "Duration" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: File Size */
            fieldFileSize: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldFileSize?c=1wa5hvshr6kv4", defaultMessage: "File Size" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: Assignee */
            fieldAssignee: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldAssignee?c=5fegogniouaz", defaultMessage: "Assignee" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field name: File Type */
            fieldFileType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.fieldFileType?c=1cuvmtz0lm3xx", defaultMessage: "File Type" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for status search - fully translatable */
            descriptionStatusApproved: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionStatusApproved?c=1ov928rwe59o9", defaultMessage: "Show me assets that have a status of [Approved]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for comments search with count - fully translatable */
            descriptionCommentsCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionCommentsCount?c=1xg73fj1h636u", defaultMessage: "Find an image that has over [25] comments" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for visuals search - fully translatable */
            descriptionVisualsCars: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionVisualsCars?c=3o6qm4pv9ypu3", defaultMessage: "Find videos with [cars in the background]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for format search - fully translatable */
            descriptionFormat: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionFormat?c=3r15gybl9tt73", defaultMessage: "Show me files in my library that are in [MP4] format" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for transcription search - fully translatable */
            descriptionTranscriptionFlour: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionTranscriptionFlour?c=2lsti0h0ers57", defaultMessage: "Find videos where the transcription contains [flour]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for date search with days - fully translatable */
            descriptionDateDays: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionDateDays?c=yptx7wkpyem2", defaultMessage: "Show any video uploads from the last [30 days]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for keyword search - fully translatable */
            descriptionKeywordExploratory: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionKeywordExploratory?c=um8m6xk8bdzb", defaultMessage: "Show me videos and assets tagged with [exploratory]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for uploader search - fully translatable */
            descriptionUploaderJeremiah: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionUploaderJeremiah?c=23wf7tvxakojv", defaultMessage: "Find videos and images uploaded by [Jeremiah]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for comments search - fully translatable */
            descriptionCommentsLighting: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionCommentsLighting?c=24rkq2dluoenc", defaultMessage: "Surface videos with comments mentioning [lighting]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for visuals search - fully translatable */
            descriptionVisualsMountains: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionVisualsMountains?c=29ijp2jn61stg", defaultMessage: "Pull clips featuring [mountains in the background]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for transcription search - fully translatable */
            descriptionTranscriptionLaunch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionTranscriptionLaunch?c=179hsw8503fcq", defaultMessage: "Find videos where transcript includes [launch sequence]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for date search with months - fully translatable */
            descriptionDateMonths: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionDateMonths?c=1i0eax6v1rjl1", defaultMessage: "List video uploads from the last [7 months]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for keyword search - fully translatable */
            descriptionKeywordConfidential: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionKeywordConfidential?c=gvg5i1kfuepc", defaultMessage: "Display media tagged with [confidential]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for uploader search - fully translatable */
            descriptionUploaderThomas: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionUploaderThomas?c=3gafduxi7yhda", defaultMessage: "List videos and images uploaded by [Thomas A]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for resolution search - fully translatable */
            descriptionResolution: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionResolution?c=2ekmz2btricxp", defaultMessage: "List videos with resolution [1920x1080]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for duration search shorter - fully translatable */
            descriptionDurationShorter: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionDurationShorter?c=24zax0dkndl5i", defaultMessage: "Display videos shorter than [30 seconds]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for file size search larger - fully translatable */
            descriptionFileSizeLarger: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionFileSizeLarger?c=2kaxtg4tp8nob", defaultMessage: "List video and image files larger than [1GB]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for comments search - fully translatable */
            descriptionCommentsApproved: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionCommentsApproved?c=2mj08336f2s8q", defaultMessage: "Locate assets with comments containing [approved]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for visuals search - fully translatable */
            descriptionVisualsPerson: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionVisualsPerson?c=15lzjhga3131o", defaultMessage: "Show me images with [a person holding a camera]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for transcription search - fully translatable */
            descriptionTranscriptionBudget: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionTranscriptionBudget?c=2iq5qofsq5mlj", defaultMessage: "Find clips mentioning [budget review] in transcription" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for date search before date - fully translatable */
            descriptionDateBefore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionDateBefore?c=ghv9j903f6mv", defaultMessage: "Pull images and videos added before [January 1, 2024]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for keyword search - fully translatable */
            descriptionKeywordMarketing: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionKeywordMarketing?c=1v02cfvnoqhna", defaultMessage: "Display images, videos and PDF''s tagged with [marketing]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for assignee search - fully translatable */
            descriptionAssignee: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionAssignee?c=2fuj94jryfbtf", defaultMessage: "Show me videos and images assigned to [Michelle]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for file type search - fully translatable */
            descriptionFileType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionFileType?c=3ch4kuw775r8v", defaultMessage: "Find any [MOV] files uploaded in the last week" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for file size search smaller - fully translatable */
            descriptionFileSizeSmaller: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionFileSizeSmaller?c=129ufwp3nv3ed", defaultMessage: "Find videos, images and PDF''s smaller than [500MB]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for duration search longer - fully translatable */
            descriptionDurationLonger: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionDurationLonger?c=2axkpi25zf7f3", defaultMessage: "Show me videos longer than [10 minutes]" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for status search - fully translatable */
            descriptionStatusNeedsReview: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "suggestionsText.descriptionStatusNeedsReview?c=2hea184l5g7n", defaultMessage: "Show me images marked [Needs Review]" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
